import { Injectable, inject } from '@angular/core';

import { EventsService, SimpleEvent, VanillaEventNames } from '@frontend/vanilla/core';
import { BehaviorSubject, Observable, filter } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class GestureStateService {
    readonly #eventsService = inject(EventsService);

    readonly #isGestureInProgress = new BehaviorSubject(false);

    get isGestureInProgress(): Observable<boolean> {
        return this.#isGestureInProgress.asObservable();
    }

    constructor() {
        this.listenToGestureEvents();
    }

    private listenToGestureEvents(): void {
        this.#eventsService.events
            .pipe(
                filter(
                    (event: SimpleEvent) =>
                        event.eventName === VanillaEventNames.GestureAnimationStart || event.eventName === VanillaEventNames.GestureAnimationEnd,
                ),
            )
            .subscribe((event: SimpleEvent) => {
                if (event.eventName === VanillaEventNames.GestureAnimationStart) {
                    this.#isGestureInProgress.next(true);
                }

                if (event.eventName === VanillaEventNames.GestureAnimationEnd) {
                    this.#isGestureInProgress.next(false);
                }
            });
    }
}
